import type { ReservationRequest } from "@lemmonhq/types";

// Tab types
export type TabValue =
  | "pending" // Pending requests
  | "declined" // Cancelled requests
  | "confirmed" // Confirmed reservations
  | "seated" // Seated/Arrived reservations
  | "completed"; // Completed reservations

export type ReservationStatus =
  | "confirmed"
  | "seated"
  | "partially-seated"
  | "arrived"
  | "completed"
  | "no-show"
  | "cancelled";
//
export type RequestStatus =
  | "pending"
  | "ignored"
  | "cancelled"
  | "confirmed"
  | "converted";

// Tab configuration — labels are translation keys, resolved in PageHeader
export const TABS = [
  {
    value: "confirmed" as const,
    labelKey: "reservations.tabs.confirmed",
    icon: "event_available",
  },
  {
    value: "pending" as const,
    labelKey: "reservations.tabs.pending",
    icon: "schedule",
  },
  {
    value: "seated" as const,
    labelKey: "reservations.tabs.in_progress",
    icon: "restaurant",
  },
] as const;

// Map tab values to what needs to be fetched
export const TAB_CONFIG: Record<
  TabValue,
  { type: "request" | "reservation"; status?: string | string[] }
> = {
  pending: { type: "request", status: "pending" },
  declined: { type: "request", status: "cancelled" },
  confirmed: {
    type: "reservation",
    status: ["confirmed", "cancelled_by_user"],
  },
  seated: {
    type: "reservation",
    status: ["seated", "partially-seated"],
  },
  completed: { type: "reservation", status: "completed" },
};

export type { DateViewMode as ViewMode } from "@lemmonhq/uikit";

// Status badge configuration for requests — labelKey is resolved via t() at render time
export const REQUEST_STATUS_CONFIG: Record<
  RequestStatus,
  {
    labelKey: string;
    bgClass: string;
    textClass: string;
    icon: string;
  }
> = {
  pending: {
    labelKey: "reservations.request_status.pending_review",
    bgClass: "bg-amber-500/10",
    textClass: "text-amber-500",
    icon: "schedule",
  },
  ignored: {
    labelKey: "reservations.status.ignored",
    bgClass: "bg-base-300",
    textClass: "text-base-content/60",
    icon: "visibility_off",
  },
  confirmed: {
    labelKey: "reservations.status.confirmed",
    bgClass: "bg-emerald-500/10",
    textClass: "text-emerald-500",
    icon: "check_circle",
  },
  cancelled: {
    labelKey: "reservations.request_status.declined",
    bgClass: "bg-rose-500/10",
    textClass: "text-rose-500",
    icon: "cancel",
  },
  converted: {
    labelKey: "reservations.request_status.booked",
    bgClass: "bg-sky-500/10",
    textClass: "text-sky-500",
    icon: "event_available",
  },
};
